<img class="recommendation-icon"
    [id]="id"
    [src]="src"
    [alt]="alt"
/>
